import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgMailIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m3 7.625 7.3484 5.001c.5951.405.8926.6075 1.2162.6859.2859.0693.5849.0693.8708 0 .3236-.0784.6211-.2809 1.2162-.6859L21 7.625M7.32 19h9.36c1.5121 0 2.2682 0 2.8458-.2861.508-.2517.9211-.6532 1.1799-1.1472C21 17.0052 21 16.2701 21 14.8V9.2c0-1.4701 0-2.2052-.2943-2.7667-.2588-.494-.6719-.8955-1.1799-1.1472C18.9482 5 18.1921 5 16.68 5H7.32c-1.5121 0-2.2682 0-2.8458.2861-.508.2517-.921.6532-1.18 1.1472C3 6.9948 3 7.7299 3 9.2v5.6c0 1.4701 0 2.2052.2943 2.7667.2588.494.6719.8955 1.18 1.1472C5.0517 19 5.8078 19 7.32 19"
    />
  </svg>
);
export default SvgMailIcon;
